module.exports = __webpack_public_path__ + "img/chek_logo.7b274ae5.jpg";